// API helpers for Bed Occupancy Approval (G11 Part B). Tenant headers are
// sent explicitly on every call — see ipdEnhancementsApi.js.

import axios from "axios";

const BASE =
  process.env.REACT_APP_BACKEND_ROUTE_URL ||
  "https://manage-dev.hlthtek.com/app/api/";

function authHeaders(extra = {}) {
  const token = sessionStorage.getItem("accessToken") || "";
  return {
    Authorization: `Bearer ${token}`,
    "APP-MODE": sessionStorage.getItem("APP_MODE") || "",
    "ORG-CODE": sessionStorage.getItem("ORG_CODE") || "",
    "USER-ACCESS-KEY": sessionStorage.getItem("USER_ACCESS_KEY") || "",
    USERNAME: sessionStorage.getItem("userName") || "",
    ...extra,
  };
}

export async function raiseOccupancyApproval({ admissionId, bedCode, notes }) {
  const body = { admission_id: admissionId, bed_code: bedCode };
  if (notes) body.notes = notes;
  const res = await axios.post(`${BASE}bed_occupancy_approval/`, body, {
    headers: authHeaders({ "Content-Type": "application/json" }),
  });
  return res?.data;
}

export async function getOccupancyApprovals({ status, department, admissionId } = {}) {
  const params = new URLSearchParams();
  if (status) params.set("status", status);
  if (department) params.set("department", department);
  if (admissionId) params.set("admission_id", admissionId);
  const qs = params.toString();
  const res = await axios.get(
    `${BASE}bed_occupancy_approval/${qs ? `?${qs}` : ""}`,
    { headers: authHeaders() }
  );
  return res?.data?.data || [];
}

export async function approveOccupancyApproval(id) {
  const res = await axios.put(
    `${BASE}bed_occupancy_approval/${id}/approve/`,
    {},
    { headers: authHeaders({ "Content-Type": "application/json" }) }
  );
  return res?.data;
}

export async function rejectOccupancyApproval(id, notes) {
  const body = {};
  if (notes) body.notes = notes;
  const res = await axios.put(
    `${BASE}bed_occupancy_approval/${id}/reject/`,
    body,
    { headers: authHeaders({ "Content-Type": "application/json" }) }
  );
  return res?.data;
}

export async function setBedApprovalRequirement(bedCode, isApprovalRequired) {
  const res = await axios.put(
    `${BASE}bed/${encodeURIComponent(bedCode)}/set_approval_requirement/`,
    { is_approval_required: isApprovalRequired },
    { headers: authHeaders({ "Content-Type": "application/json" }) }
  );
  return res?.data;
}
